import Checkbox from "components/atoms/Checkbox";
import Heading from "components/atoms/Heading";
import Image from "components/atoms/Image";
import Loading from "components/atoms/Loading";
import Select2 from "components/atoms/Select";
import Text from "components/atoms/Text";
import Fieldrow, { Fieldcell } from "components/molecules/Fieldrow";
import Table, {
  TableBody,
  TableHead,
  Td,
  Th,
  Tr,
} from "components/molecules/Table";
import Modal from "components/organisms/Modal";
import ModalBody from "components/organisms/Modal/Body";
import ModalHeader from "components/organisms/Modal/Header";
import { BASE_URL } from "constants/env";
import supplie_11_15 from "images/product/supplies/11-15.png";
import supplie_16_30 from "images/product/supplies/16-30.png";
import supplie_3_5 from "images/product/supplies/3-5.png";
import supplie_6_10 from "images/product/supplies/6-10.png";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRange,
  fetchTextDataViaRange,
  requestFetchSuplyProduct,
  requestFetchSuppliesByHp,
} from "redux/actions/products/supply";
import "./index.scss";
interface FormSupplyProps {
  onToggleForm?: (toogle: number) => void;
}

const FormSupply: React.FC<FormSupplyProps> = ({ onToggleForm }) => {
  const [supplySelected, setSupplySelected] = useState("");
  const [rangeOptions, setRangeOptions] = useState([]);
  const [rangeOption, setRangeOption] = useState("");

  const {
    data: { supplies, suppliesByHp },
    loading: supplyLoading,
  } = useSelector((state: any) => state.products.supply);
  const dispatch = useDispatch();
  const suppliesOption =
    supplies.length > 0 &&
    supplies
      .map((sup: any) => ({
        label: sup.value,
        value: sup.id,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

  const onChangeSupplyOption = (val: any) => {
    setSuppliesChecked([]);
    setSupplySelected(val.label);
    dispatch(requestFetchSuppliesByHp(val.value));
  };
  // range option select start
  const onChangeRangeOption = (val: any) => {
    setRangeOption(val.value);
  };
  useEffect(() => {
    if (rangeOptions.length > 0 && !rangeOption) {
      setRangeOption(rangeOptions[0].value);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rangeOptions]);
  // range option select end

  useEffect(() => {
    dispatch(requestFetchSuplyProduct());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (suppliesOption.length > 0 && !supplySelected) {
      setSupplySelected(suppliesOption[0].label);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suppliesOption]);

  useEffect(() => {
    if (supplySelected) {
      const rangeOpts = fetchRange(supplySelected);
      setRangeOptions(rangeOpts);
      setRangeOption(rangeOpts[0].value);
    }
  }, [supplySelected]);
  const renderImg = () => {
    const range = parseInt(rangeOption);
    if (range >= 6 && range <= 10) {
      return <Image src={supplie_6_10} alt="Supply image" />;
    } else if (range >= 11 && range <= 15) {
      return <Image src={supplie_11_15} alt="Supply image" />;
    } else if (range >= 16 && range <= 30) {
      return <Image src={supplie_16_30} alt="Supply image" />;
    } else {
      return <Image src={supplie_3_5} alt="Supply image" />;
    }
  };
  const dataText = fetchTextDataViaRange(rangeOption);

  //
  const [suppliesChecked, setSuppliesChecked] = useState([]); // dung` de check box tinh tong tien vat tu
  const onCheckSupply = (check: boolean, value: any) => {
    if (check) {
      setSuppliesChecked(suppliesChecked.concat(value));
    } else {
      setSuppliesChecked(suppliesChecked.filter((x: any) => x.id !== value.id));
    }
  };
  useEffect(() => {
    if (suppliesByHp.length > 0) {
      setSuppliesChecked(suppliesByHp);
    }
  }, [suppliesByHp]);
  let totalAmountOfSupplies = useMemo(() => {
    return suppliesChecked.length > 0
      ? suppliesChecked
          .map(
            sup =>
              +sup.price_per_unit *
              +(sup.ratio * parseInt(rangeOption) + sup.base_quantity),
          )
          .reduce((total, current) => total + current, 0)
      : 0;
  }, [suppliesChecked, rangeOption]);

  return (
    <Modal sizeLg isOpen={true} onCloseRequest={onToggleForm} fullWidthContent>
      <ModalHeader onCloseRequest={onToggleForm}>
        <Heading type="h3" modifiers={["center"]}>
          Chi phí vật tư tạm tính
        </Heading>
        <div className="supplies-content">
          <Fieldrow>
            <Fieldcell>
              <fieldset>
                <legend>Khoảng cách cục nóng và lạnh</legend>
                <Select2
                  options={rangeOptions}
                  modifiers={["border-none"]}
                  placeholder="Khoảng cách cục nóng và lạnh"
                  onChange={onChangeRangeOption}
                  value={rangeOptions.find((x: any) => x.value === rangeOption)}
                />
              </fieldset>
            </Fieldcell>
            <Fieldcell>
              <fieldset>
                <legend>Công suất máy lạnh</legend>
                <Select2
                  options={suppliesOption}
                  modifiers={["border-none"]}
                  placeholder="Công suất máy lạnh"
                  onChange={onChangeSupplyOption}
                  value={
                    suppliesOption.length > 0 &&
                    suppliesOption.find((x: any) => x.label === supplySelected)
                  }
                />
              </fieldset>
            </Fieldcell>
          </Fieldrow>
          <Fieldrow>
            <Fieldcell>
              <div className="supplies-content-img">{renderImg()}</div>
            </Fieldcell>
            <Fieldcell>
              <div className="supplies-content-info">
                <p className="supplies-content-info-1">{dataText.title}</p>
                {dataText.content.map((text, i) => (
                  <Text key={i}>● {text}</Text>
                ))}
              </div>
            </Fieldcell>
          </Fieldrow>
        </div>
      </ModalHeader>
      {!supplyLoading ? (
        <ModalBody>
          <Table>
            <TableHead>
              <Tr>
                <Th>Vật liệu</Th>
                <Th>{""}</Th>
                <Th>{""}</Th>
                <Th>Đơn giá</Th>
                <Th>Số lượng</Th>
                <Th>Thành tiền</Th>
              </Tr>
            </TableHead>
            <TableBody>
              {suppliesByHp.map((sup: any, i: number) => {
                const calculation =
                  sup.ratio * parseInt(rangeOption) + sup.base_quantity;
                const totalSingleUnit =
                  parseInt(sup.price_per_unit) * parseInt(calculation);
                return (
                  <Tr key={i}>
                    <Td modifiers={["textBlue", "center"]}>
                      <Checkbox
                        name="chkSupply"
                        type="checkbox"
                        checked={suppliesChecked.find(
                          (x: any) => x.id === sup.id,
                        )}
                        onChange={(e: any) =>
                          onCheckSupply(e.target.checked, {
                            ...sup,
                            totalSingleUnit,
                          })
                        }
                      />
                    </Td>
                    <Td modifiers={["center"]}>
                      <div className="supplies-content-supply-img">
                        <Image
                          alt="Supply Image"
                          src={`${BASE_URL}/${sup.thumbnail}`}
                        />
                      </div>
                    </Td>
                    <Td>{sup.name}</Td>
                    <Td modifiers={["center", "textRight"]}>
                      {window.formatMoney(sup.price_per_unit)}
                    </Td>
                    <Td modifiers={["center", "textRight"]}>
                      {calculation} {sup.unit}
                    </Td>
                    <Td modifiers={["center", "textRight"]}>
                      {window.formatMoney(totalSingleUnit)}
                    </Td>
                  </Tr>
                );
              })}
            </TableBody>
          </Table>
          <div className="supplies-content-sum">
            <div className="supplies-content-sum-num">
              <Text size="lg" modifiers={["right"]} weight="bold">
                TỔNG CỘNG: {window.formatMoney(totalAmountOfSupplies)}
              </Text>
            </div>
            <Text size="sm" weight="bold" modifiers={["center", "dark"]}>
              Thông tin chi phí vật tư trên chỉ là tạm tính và chưa bao gồm VAT,
              chi phí tại thời điểm lắp đặt có thể thay đổi tùy theo điều kiện
              thực tế.
            </Text>
          </div>
        </ModalBody>
      ) : (
        <Loading />
      )}
    </Modal>
  );
};

FormSupply.defaultProps = {};

export default FormSupply;
